import * as maplibre from "maplibre-gl";
import maplibreWorkerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";

maplibre.setWorkerUrl(maplibreWorkerUrl);

export { maplibre };
